var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"icon",attrs:{"id":"yt-button","src":require("../assets/yt_icon_rgb.png"),"alt":"Youtube"},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }